import { useEffect } from 'react';
import { supabase, isSupabaseConfigured } from '../lib/supabase';
import { useAppStore } from '../stores/appStore';

export function useAuth() {
  const { setUser, setOrgId } = useAppStore();

  useEffect(() => {
    if (!isSupabaseConfigured) return;

    async function loadUser(userId: string, email: string) {
      const { data } = await supabase
        .from('users')
        .select('org_id, full_name, role, avatar_url, created_at')
        .eq('id', userId)
        .single();

      if (data) {
        setUser({ id: userId, email, ...data } as import('../types').User);
        setOrgId(data.org_id);
      }
    }

    // Restore existing session on mount
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        loadUser(session.user.id, session.user.email ?? '');
      }
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session?.user) {
        loadUser(session.user.id, session.user.email ?? '');
      } else if (event === 'SIGNED_OUT') {
        setUser(null);
        setOrgId(null);
      }
    });

    return () => subscription.unsubscribe();
  }, [setUser, setOrgId]);
}
